import Helpers from '@wielink-application/shared/js/helpers/Helpers';
import _ from 'lodash';
class Ajax {
    patch(url, data = {}, config = {}) {
        data._method = 'PATCH';
        return this._request(url, 'POST', data, config);
    }
    put(url, data, config) {
        data._method = 'PUT';
        return this._request(url, 'POST', data, config);
    }
    post(url, data, config) {
        return this._request(url, 'POST', data, config);
    }
    get(url, data, config) {
        return this._request(url, 'GET', data, config);
    }
    delete(url, data, config) {
        data._method = 'DELETE';
        return this._request(url, 'POST', data, config);
    }

    _request(url, method, data = {}, config = {}) {
        let processData = true;
        if (method == 'POST') {
            data = JSON.stringify(data);
            processData = false;
        }
        console.log(data);
        let defaultConfig = {
            url: url,
            method: method,
            contentType: "application/json",
            processData: processData,
            data: data,
            success: this.success.bind(this, config),
            error: this.error.bind(this, config),
        };
        config = _.merge(defaultConfig, config);

        return $.ajax(config);
    }
    success(config, response) {
        Helpers.Message.flash(response.message, response.type);
        if (config.afterSuccess) {
            config.afterSuccess.call(response);
        }
    }
    error(config, response) {
        Helpers.Message.error(response.responseJSON.message);
        if (config.afterError) {
            config.afterError.call(response);
        }
    }

}

export default Ajax;
